const hexToRgb = require('./hexToRgb');

const rgba = (hex, a = 1) => {
  const { r, g, b } = hexToRgb(hex);

  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

module.exports = rgba;
